/**
 * @generated SignedSource<<694138c8d9f088a98ab9cb6397e315f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DevMenuTrackerProcessingQuery$variables = {};
export type DevMenuTrackerProcessingQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly smartTrackers: ReadonlyArray<{
        readonly id: string;
        readonly isActive: boolean;
        readonly name: string;
      }>;
    };
  };
};
export type DevMenuTrackerProcessingQuery = {
  response: DevMenuTrackerProcessingQuery$data;
  variables: DevMenuTrackerProcessingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "SmartTracker",
  "kind": "LinkedField",
  "name": "smartTrackers",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DevMenuTrackerProcessingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DevMenuTrackerProcessingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b8ba85e6453023b403c28dead52c4a8e",
    "id": null,
    "metadata": {},
    "name": "DevMenuTrackerProcessingQuery",
    "operationKind": "query",
    "text": "query DevMenuTrackerProcessingQuery {\n  viewer {\n    account {\n      smartTrackers {\n        id\n        name\n        isActive\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "81415e4c26ecb310c7cda914e47bdf06";

export default node;
